export default "__VITE_ASSET__620b7dec__"